"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteTransferAccount = deleteTransferAccount;
exports.editAlipayAccountNumber = editAlipayAccountNumber;
exports.editTransferAccount = editTransferAccount;
exports.queryAlipayAccountNumber = queryAlipayAccountNumber;
exports.queryTransferAccountDetail = queryTransferAccountDetail;
exports.queryTransferAccountPage = queryTransferAccountPage;
exports.setDefaultTransferAccount = setDefaultTransferAccount;
var _request = _interopRequireDefault(require("@/utils/request"));
function queryAlipayAccountNumber(params) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/queryAlipayAccountNumber',
    method: 'get',
    params: params
  });
}
function editAlipayAccountNumber(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/editAlipayAccountNumber',
    method: 'post',
    data: data
  });
}
function queryTransferAccountPage(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/queryTransferAccountPage',
    method: 'post',
    data: data
  });
}
function editTransferAccount(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/editTransferAccount',
    method: 'post',
    data: data
  });
}
function setDefaultTransferAccount(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/setDefaultTransferAccount',
    method: 'post',
    data: data
  });
}
function deleteTransferAccount(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/deleteTransferAccount',
    method: 'post',
    data: data
  });
}
function queryTransferAccountDetail(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/queryTransferAccountDetail',
    method: 'post',
    data: data
  });
}